import * as React from 'react';
import { AccordionItemContext, } from '../accordion-item/accordion-item-context';
export default class AccordionHeaderCore extends React.Component {
    getArrow() {
        const { AccordionArrow } = this.props.components;
        return (React.createElement(AccordionArrow, { id: this.context.id, onClick: this.context.onClick, onMouseEnter: this.context.onMouseEnter, onMouseLeave: this.context.onMouseLeave }));
    }
    render() {
        return (React.createElement("div", { className: "accordion__header", id: `${this.context.id}-header`, ref: this.props.headerRef },
            React.createElement("div", { className: "accordion__header-inner" },
                this.props.asideContent,
                this.props.children,
                this.props.arrowLocation === 'inner' && this.getArrow()),
            this.props.arrowLocation === 'header' && this.getArrow()));
    }
}
AccordionHeaderCore.contextType = AccordionItemContext;
